"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgClothesDryer = function SvgClothesDryer(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 4.088)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.433 7.976c-.315 1.162-.766 1.846-1.353 2.05-.88.307-.457 1.17 0 1.974",
    stroke: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.295 14.03 3.779-2.494m5.138-3.392L19.56 1.4M2 2.538.295 1.412M19.41 14.03 9.155 7.26",
    stroke: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.577 1.412H19.41M14.5 3v2",
    stroke: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.446 1.5H1.664l.399 1.385h.856v8.657H9.14V2.885h1.008l.297-1.385z",
    stroke: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#4D4D4D",
    cx: 14.5,
    cy: 6.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 1.5a1.5 1.5 0 0 0 3 0",
    stroke: "#4A4A4A"
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgClothesDryer);
var _default = exports["default"] = Memo;